/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.LogisticsQuotationInfoResponseDto>
>;
export function request(
  params: API.tms.logisticsQuotationInfo.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotationInfo/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
